App.namespace('components.locale_links', () => {
  const init = () => {
    const localeManager = App.components.locale_manager;

    $('.js-change-locale').on('click', (event) => {
      const target = $(event.currentTarget);
      const locale = target.data('locale');
      const homepageUrl = target.attr('href');

      App.track.event('clicked_to_location_page', {
        section: 'footer',
        element: 'footer_link',
        element_value: target.text().trim(),
        interaction: 'click',
      });

      localeManager.setLocale(locale);
      window.location = homepageUrl;
    });
  };

  $(init);
});
